import { Component, OnInit, ViewContainerRef } from "@angular/core";
import {
  IPopoverMessage,
  PopoverService,
} from "../../_services/popover.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

@Component({
  selector: "popover-container",
  templateUrl: "./popover-container.component.html",
  styleUrls: ["./popover-container.component.scss"],
  animations: [
    trigger("showHide", [
      state(
        "show",
        style({
          opacity: 1,
        })
      ),
      state(
        "hide",
        style({
          display: "none",
          opacity: 0,
        })
      ),
      state(
        "void",
        style({
          display: "none",
          opacity: 0,
        })
      ),
      transition("show => hide", [animate("0.2s")]),
      transition("* => void", [animate("0.2s")]),
      transition("* => show", [animate("0.2s")]),
      transition("* => hide", [animate("0.2s")]),
      transition("hide => show", [animate("0.2s")]),
    ]),
  ],
})
export class PopoverContainerComponent implements OnInit {
  public showStatus: "show" | "hide" = "show";
  public messages: IPopoverMessage[] = [];
  public currentMessage: IPopoverMessage | null = null;
  private defaultDuration: number = 5000;
  private defaultDurationIfMultiple: number = 2000;
  private timerId: number;
  constructor(
    private vcr: ViewContainerRef,
    private popoverService: PopoverService
  ) {
    this.popoverService.popoverMessage.subscribe((message) => {
      this.pushNewMessageToCue(message);
    });
  }

  public ngOnInit() {}

  public closePopover() {
    this.showStatus = "hide";
    this.messages = [];

    this.currentMessage = null;
  }
  private timeoutFinished() {
    if (this.messages.length) {
      this.currentMessage = this.messages[this.messages.length - 1];
      this.messages.pop();
      const timeOutDuration = this.messages.length
        ? this.defaultDurationIfMultiple
        : this.defaultDuration;
      this.timerId = window.setTimeout(() => {
        this.timeoutFinished();
      }, timeOutDuration);
    } else {
      this.closePopover();
    }
  }

  private pushNewMessageToCue(message: IPopoverMessage) {
    if (this.currentMessage) {
      this.messages.unshift(message);
      return;
    }

    this.showStatus = "show";
    this.currentMessage = message;
    this.timerId = window.setTimeout(() => {
      this.timeoutFinished();
    }, this.defaultDuration);
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/popover/popover-container.component.ts